import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface ErrorModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ show, onClose, title, message }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" style={{ backgroundColor: "var(--tu-teal)"}} onClick={onClose}>
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorModal;
